class CrossSellComponent {
  constructor(containerSelector, productHandle) {
    this.container = document.querySelector(containerSelector);
    this.productHandle = productHandle;
    this.selectedProductsKey = `selectedProducts_${this.productHandle}`;
    this.selectedProducts = null;

    this.clearPreviousData();
    this.initialize();
  }

  async initialize() {
    try {
      const storedProducts = sessionStorage.getItem(this.selectedProductsKey);
      if (storedProducts) {
        this.selectedProducts = JSON.parse(storedProducts);
        if (Array.isArray(this.selectedProducts) && this.selectedProducts.length > 0) {
          this.renderProducts(this.selectedProducts);
          return;
        }
      }

      const response = await fetch(`/products/${this.productHandle}?view=cross-sell`);
      const html = await response.text();
      const temp = document.createElement('div');
      temp.innerHTML = html;

      const dataScript = temp.querySelector('#cross-sell-data');
      
      if (!dataScript) return this.hideSection();

      const crossSellData = JSON.parse(dataScript.textContent);
      await this.loadProducts(crossSellData.collections);
    } catch (error) {
      console.warn('CrossSell error', error);
      this.hideSection();
    }
  }

  clearPreviousData() {
    for (let key in sessionStorage) {
      if (key.startsWith('selectedProducts_') && key !== this.selectedProductsKey) {
        sessionStorage.removeItem(key);
      }
    }
  }

  hideSection() {
    const section = document.querySelector('.people-also-bought-collection');
    if (section) section.classList.remove('active');
  }

  showSection() {
    const placeHolder = document.querySelector('.people-also-bought-placeholder-main-wrapper ')
    const section = document.querySelector('.people-also-bought-collection .featured-collection__inner');
    if (placeHolder) placeHolder.classList.remove('active');
    if (section) section.classList.add('active');
  }

  async loadProducts(collections) {
    
    let allProducts = [];
    let footwear = [];

        // Collect all related products and all footwear products
        for (const col of collections) {

          for (const related of col.relatedCollections) {
            if (related.products && related.products.length) {
              const availableProducts = related.products.filter(p => p.available); //To show only products which are available
              if (related.handle.includes('footwear')) {
                footwear.push(...availableProducts);
              } else {
                allProducts.push(...availableProducts);
              }
            }
          }
        }
    

    if (!allProducts.length) return this.hideSection();
    

    const nonFootwear = allProducts.filter(p =>
      !p.collections?.some(c => c.handle.includes('footwear'))
    );

    let selected = [];

    // Always include one random footwear if available
    if (footwear.length) {
      const randomFootwear = footwear[Math.floor(Math.random() * footwear.length)];
      selected.push(randomFootwear);
    }

    const others = [...nonFootwear, ...footwear].filter(p => !selected.includes(p));
    while (selected.length < 9 && others.length) {
      const index = Math.floor(Math.random() * others.length);
      selected.push(others.splice(index, 1)[0]);
    }

    sessionStorage.setItem(this.selectedProductsKey, JSON.stringify(selected));
    this.renderProducts(selected);
  }

  renderProducts(products) {
    if (this.container) {
      this.container.innerHTML = products.map(p => p.cardHTML).join('');
      this.showSection();
    }
  }
}

// Usage
function initCrossSell() {
  const section = document.querySelector('.people-also-bought-collection');
  if (!section) return;

  const pathParts = window.location.pathname.split('/');
  const productHandleIndex = pathParts.indexOf('products') + 1;
  const productHandle = pathParts[productHandleIndex];

  if (!productHandle) return;

  new CrossSellComponent('.random-products-container', productHandle);
}

initCrossSell();